import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';
import {StorageKeys, StorageTypes} from 'common/constants/storageKeys';

export default function facilityDetailsUpdateTimesButtonClicked({
    spotId,
    editedStartTime,
    editedEndTime,
}) {
    try {
        const properties = {
            partner_affiliate:
                StorageUtils.get(
                    StorageKeys.PARTNER_AFFILIATE,
                    StorageTypes.SESSION
                ) || null,
            facility_id: parseInt(spotId, 10),
            edited_start_time: editedStartTime,
            edited_end_time: editedEndTime,
        };

        SegmentUtils.track({
            event: 'Facility Details Update Time Button Clicked',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage:
                'Segment Event Failed - facilityDetailsUpdateTimesButtonClicked',
        });
    }
}
